<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            Go To Today
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small> mdi-chevron-left </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small> mdi-chevron-right </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right> mdi-menu-down </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          interval-minutes="30"
          first-interval="16"
          interval-count="20"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:more="viewDay"
          @click:date="viewDay"
        >
          <template v-slot:day-body="{ date, week }">
            <div
              class="v-current-time"
              :class="{ first: date === week[0].date }"
              :style="{ top: nowY }"
            ></div>
          </template>
          <template v-slot:event="{ event, timeSummary }">
            <div class="pl-1">
              <div>{{ timeSummary() }}</div>
              <div class="text-center">
                {{ event.course_name }} Section {{ event.section }}
              </div>
              <div class="text-center">
                {{ event.teachers }}
              </div>
            </div>
          </template>
        </v-calendar>
      </v-sheet>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    user_id: {
      type: Number,
      required: true,
    },
    user_name: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    focus: "",
    type: "week",
    typeToLabel: {
      month: "Month",
      week: "Week",
      day: "Day",
    },
    colors: [
      "#7986CB",
      "#EC407A",
      "#E65100",
      "#BA68C8",
      "#0288D1",
      "#78909C",
      "#009688",
      "#558B2F",
      "#A1887F",
      "#F4511E",
      "#43A047",
    ],
    schedule: {
      events: [],
    },
    ready: false,
  }),

  watch: {
    user_id: ["getSchedule"],
  },
  computed: {
    events() {
      return this.schedule.events;
    },

    //this is used to draw a line to show current time on calendar
    cal() {
      return this.ready ? this.$refs.calendar : null;
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + "px" : "-10px";
    },
    //now line end
  },
  methods: {
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },

    getEventColor(event) {
      let index =
        (event.course_id + event.section.charCodeAt(0)) % this.colors.length;
      return this.colors[index];
    },

    setToday() {
      this.focus = "";
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    // //this is used to draw a line to show current time on calendar
    getCurrentTime() {
      return this.cal
        ? this.cal.times.now.hour * 60 + this.cal.times.now.minute
        : 0;
    },
    scrollToTime() {
      const time = this.getCurrentTime();
      const first = Math.max(0, time - (time % 30) - 30);

      this.cal.scrollToTime(first);
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000);
    },
    getSchedule() {
      this.schedule.events = [];
      this.$sisApi("get", `schedules/${this.user_id}`).then((response) => {
        response.data.school_days.forEach((sd) => {
          sd.drafts.forEach((draft) => {
            response.data.schedules
              .filter((s) => s.day_cycle == draft.cycle && s.drid == draft.id)
              .forEach((s) => {
                this.schedule.events.push({
                  ...s,
                  start: sd.date + " " + s.start_time,
                  end: sd.date + " " + s.end_time,
                  cycle: draft.cycle,
                });
              });
          });
        });
      });
    },
  },
  mounted() {
    this.schedule.events = [];
    this.getSchedule();
    //this is used to draw a line to show current time on calendar
    this.ready = true;
    this.scrollToTime();
    this.updateTime();
    //now line end
  },
};
</script>
<style lang="scss" scoped>
.v-current-time {
  height: 2px;
  background-color: #ea4335;

  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: "";
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}
</style>
